
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { deriveDependencyScope, type ScopeParams } from '../../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';

/**
 * Hook that sets the dependency scope in the Redux store based on the provided context
 */
export function useSetDependencyScope(ctx: ScopeParams) {
  const dispatch = useDispatch();
  const { projectId, revisionId, projectGroup, projectGroupRelease } = ctx;
  useEffect(() => {
    const scope = deriveDependencyScope(ctx);
    if (scope) {
      dispatch(DependenciesV2Store.actions.setScope(scope));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, projectId, revisionId, projectGroup, projectGroupRelease]);
}
